import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DevOpsActionParameter } from 'erm-sdk';

@Component({
  standalone: false,
  selector: 'app-add-new-dev-ops-action-parameter',
  templateUrl: './add-new-dev-ops-action-parameter.component.html',
  styleUrls: ['./add-new-dev-ops-action-parameter.component.scss']
})
export class AddNewDevOpsActionParameterComponent {

  selectedParameterDataType?: string;
  devOpsActionParameter: DevOpsActionParameter;

  constructor(private dialogRef: MatDialogRef<AddNewDevOpsActionParameterComponent>) {
    this.devOpsActionParameter = {} as DevOpsActionParameter;
  }

  onParameterDataTypeChanged(): void {
    if (this.selectedParameterDataType === 'String') {
      this.devOpsActionParameter.isString = true;
      this.devOpsActionParameter.isBoolean = false;
      this.devOpsActionParameter.isNumber = false;
      this.devOpsActionParameter.value = '';
    }
    else if (this.selectedParameterDataType === 'Boolean') {
      this.devOpsActionParameter.isString = false;
      this.devOpsActionParameter.isBoolean = true;
      this.devOpsActionParameter.isNumber = false;
      this.devOpsActionParameter.value = false;
    }
    else if (this.selectedParameterDataType === 'Number') {
      this.devOpsActionParameter.isString = false;
      this.devOpsActionParameter.isBoolean = false;
      this.devOpsActionParameter.isNumber = true;
      this.devOpsActionParameter.value = undefined;
    }
  }

  add(): void {
    this.dialogRef.close({ data: this.devOpsActionParameter });
  }

  close(): void {
    this.dialogRef.close({ data: undefined });
  }
}
